import { withInstall } from '@tw-element/utils'
import Drawer from './src/drawer.vue'

export const TwDrawer = withInstall(Drawer)
export default TwDrawer

export * from './src/drawer'
